import { sha256 as sha256Fallback } from '@noble/hashes/sha256'

/**
 * SHA-256 that also works where the Web Crypto API is unavailable.
 *
 * crypto.subtle is only exposed to secure contexts. The native app is served
 * from a custom scheme (capacitor:// on iOS) that the WKWebView does not treat
 * as one, so crypto.subtle is undefined there and any digest call throws.
 * crypto.getRandomValues stays available — only SubtleCrypto is withheld.
 *
 * Prefer the platform implementation where it exists and fall back to a
 * pure-JS one otherwise, so hashing behaves identically on web and native.
 */
export const sha256 = async (data: Uint8Array<ArrayBuffer>): Promise<Uint8Array> => {
  if (globalThis.crypto?.subtle) {
    const digest = await globalThis.crypto.subtle.digest('SHA-256', data)
    return new Uint8Array(digest)
  }
  return sha256Fallback(data)
}
